import React, {useState, useEffect} from "react";
import publicUserApi from "@api/public-user";
import {List, Typography, Row, Col} from 'antd';
import {ClientPlatformOptions} from "../../../../models/clientPlatform";
import __i18n from "../../../../intl/__i18n";
import PlatformIcon from "../../../custom/PlatformIcon";
import {ApplicationStoreOptions} from "../../../../models/store";


interface Props {
  userId: string;
}


const Index = (props: Props) => {
  const {userId} = props;
  const [data, setData] = useState([]);
  
  
  useEffect(() => {
    publicUserApi.getUserLastLoginData({
        params: {
          id: userId,
        }
      })
      .then(({data}) => {
        setData(data ? [data] : [])
      })
      .catch(error => {
      });
  }, [])
  
  return (
    <List
      header={<div>{__i18n("User Last Login")}</div>}
      bordered
      dataSource={data}
      renderItem={item => (
        <List.Item>
          <Row gutter={24}>
            <Col span={8}>
              <PlatformIcon platform={item.platform}/>
              {" "}
              {ClientPlatformOptions.find(opt => opt.value === item.platform)["label"]}
            </Col>
            
            <Col span={8}>
              <label>{__i18n("Brand")}</label>
              {" "}
              {item.brand || "-"}
            </Col>
  
            <Col span={8}>
              {ApplicationStoreOptions.find( opt => opt.value === item.store)["label"]}
            </Col>
          </Row>
        </List.Item>
      )}
    />
  )
};


export default Index




